<template>
  <div class="index">
    <banner></banner>
    <news></news>
    <functions></functions>
    <recommend></recommend>
    <zhuanye></zhuanye>
    <info></info>
    <region :data="data.ip_info" @reload='reload111()'></region>
  </div>
</template>

<script>
  import news from '../components/index/news.vue'
  import banner from '../components/banner.vue'
  import xinxi from '../components/xinxi.vue'
  import functions from '../components/index/functions.vue'
  import recommend from '../components/index/recommend.vue'
  import zhuanye from '../components/index/zhuanye.vue'
  import info from '../components/index/info.vue'
  import region from '../components/region.vue'
  import backTop from '../components/backTop.vue'
  export default {
    components: {
      banner,
      backTop,
      xinxi,
      functions,
      recommend,
      info,
      zhuanye,
      region,
      news
    },
    data() {
      return {
        data: []
      }
    },
    created() {
      this.$http.index().then(res => {
        this.data = res.data
      })
    },
    methods: {
      reload111() {
        location.reload()
      }
    }
  }
</script>

<style scoped>
  .index {
    background-color: #FCFCFC;
  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue